import { Eye, EyeOff } from "lucide-react";

interface CustomInputProps {
  type: string;
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
  error: string;
  icon: React.ReactNode;
  showPassword?: boolean;
  toggleShowPassword?: () => void;
}

const CustomInput: React.FC<CustomInputProps> = ({
  type,
  placeholder,
  value,
  onChange,
  error,
  icon,
  showPassword,
  toggleShowPassword,
}) => (
  <div className="space-y-2">
    <div className="relative">
      {icon}
      <input
        type={showPassword ? "text" : type}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={`w-full pl-10 ${
          toggleShowPassword ? "pr-10" : "pr-3"
        } h-12 bg-white border-2 rounded-lg px-3 py-2 text-sm transition-colors ${
          error
            ? "border-red-300 focus:border-red-500"
            : "border-gray-200 focus:border-blue-500"
        }`}
      />
      {toggleShowPassword && (
        <button
          type="button"
          onClick={toggleShowPassword}
          className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
        >
          {showPassword ? (
            <EyeOff className="w-5 h-5" />
          ) : (
            <Eye className="w-5 h-5" />
          )}
        </button>
      )}
    </div>
    {error && <p className="text-sm text-red-600 ml-1">{error}</p>}
  </div>
);

export default CustomInput;
